import { render, staticRenderFns } from "./Manning.vue?vue&type=template&id=036dd548&scoped=true&"
import script from "./Manning.vue?vue&type=script&lang=js&"
export * from "./Manning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036dd548",
  null
  
)

export default component.exports